/**
 * Days elapsed since the payment due date. Returns null when the payment is up
 * to date or there is no usable date.
 *
 * The API serializes the due date without a time zone ("2026-07-15T00:00:00"),
 * so only the YYYY-MM-DD part is used: passing it to `new Date()` would parse it
 * in the browser's zone and shift the count by a day.
 */
export function getDaysOverdue(dueDate: string | null, today: Date = new Date()): number | null {
  if (!dueDate) return null;

  const [year, month, day] = dueDate.split('T')[0].split('-').map(Number);
  if (!year || !month || !day) return null;

  // The SOAP wrapper cannot tell "no date" from DateTime.MinValue and returns
  // 0001-01-01, which would otherwise render as ~740,000 days overdue.
  if (year < 2000) return null;

  const due = Date.UTC(year, month - 1, day);
  const now = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const days = Math.floor((now - due) / 86_400_000);

  return days >= 0 ? days : null;
}
